// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PayrollDiscountNestedInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import { registerContract } from './validate'

export interface PayrollDiscountNestedInput {
amount: number
deduction_id?: number
advance_id?: number
}

registerContract('PayrollDiscountNestedInput', {
  amount:       { type: 'number',  required: true },
  deduction_id: { type: 'number',  required: false },
  advance_id:   { type: 'number',  required: false },
})
